import { Component, OnInit } from '@angular/core';
import { DpSectionForm } from '@docpath/webcomponents';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { CloudService } from 'src/app/shared/services/cloud.service';

import { GeneralConfig, GeneralSettingsConfig } from './general-config.model';
import { GeneralFormService } from './services/general-form.service';
import { GeneralHttpService } from './services/general-http.service';

@Component({
  selector: 'app-configuration-general',
  templateUrl: './general.component.html'
})
export class GeneralComponent implements OnInit {

  private readonly header = 'general.form';

  faCog = faCog;
  sectionForm: DpSectionForm;

  constructor(
    private readonly generalHttpService: GeneralHttpService,
    private readonly generalService: GeneralFormService,
    private readonly cloudService: CloudService
  ) {
    this.sectionForm = this.generalService.getSectionForm();
  }

  ngOnInit(): void {
    this.generalHttpService.getConfig().subscribe(config => {
      this.sectionForm.setValue(config);
    });

  }

  submitForm() {
    const config = this.sectionForm.formGroup?.value;
    let generalSettingsConfig!: GeneralSettingsConfig;

    if (!this.cloudService.isModeCloud()) {
      const { ...configWithoutSeconds } = config.general;
      generalSettingsConfig = new GeneralSettingsConfig(
        configWithoutSeconds.workingDirectory,
        configWithoutSeconds.batchSizeDeletingJobs,
        configWithoutSeconds.refreshLastHour
      );
    }

    const modifiedConfig = new GeneralConfig(
      generalSettingsConfig,
      config.log,
      config.email,
      config.sms
    );

    this.generalHttpService.updateConfig(modifiedConfig).subscribe(() => {
      this.sectionForm.setValue(config);
    });
  }
}
